import axiosInstance from './axiosConfig';


export const SubscriptionService = {
    getPlans: async () => {
        const response = await axiosInstance.get('/stripe/plans');
        return response.data;
    },

    createCheckoutSession: async (planId, quantity, amountDollars, isFreeTrial, page) => {
        const response = await axiosInstance.post('/stripe/create-checkout-session', {
            planId,
            successUrl: `https://app.speakyourmenu.com/subscription`,
            cancelUrl: `https://app.speakyourmenu.com/${page}`,
            amountDollars,
            isFreeTrial

        });
        return response.data;
    },

    getAllTransactions: async () => {
        try {
            const response = await axiosInstance.get('/stripe/transactions');
            return response.data;
        } catch (error) {
            console.error('Error fetching transactions:', error);
            throw error;
        }
    },

    getSubscription: async () => {
        try {
            const response = await axiosInstance.get('/stripe/subscription');
            return response.data;
        } catch (error) {
            console.error('Error fetching subscription:', error);
            throw error;
        }
    },

    cancelSubscription: async () => {
        const response = await axiosInstance.post('/stripe/cancel-subscription');
        return response.data;
    },

    getFinancialMetrics: async (timeframe) => {
        const url = timeframe
            ? `/stripe/financial-metrics?timeframe=${timeframe}`
            : '/stripe/financial-metrics';
        const response = await axiosInstance.get(url);
        return response.data;
    },

    getSubscriptionTable: async () => {
        const response = await axiosInstance.get('/stripe/subscription-table');
        return response.data;
    }
};

